__turbopack_context__.v({
  "accent": "_23_uaW_accent",
  "ai": "_23_uaW_ai",
  "c": "_23_uaW_c",
  "christmas": "_23_uaW_christmas",
  "deer": "_23_uaW_deer",
  "flyOver": "_23_uaW_flyOver",
  "glow": "_23_uaW_glow",
  "halloween": "_23_uaW_halloween",
  "hat": "_23_uaW_hat",
  "ivit": "_23_uaW_ivit",
  "liveNow": "_23_uaW_liveNow",
  "logo": "_23_uaW_logo",
  "nose": "_23_uaW_nose",
  "peekOut": "_23_uaW_peekOut",
  "peekOutDeer": "_23_uaW_peekOutDeer",
  "prance": "_23_uaW_prance",
  "pride": "_23_uaW_pride",
  "stpatty": "_23_uaW_stpatty",
  "svg": "_23_uaW_svg",
  "twinkle": "_23_uaW_twinkle",
});
